export enum IntegrationServices {
  HUBSPOT = 'hubspot',
  ZAPIER = 'zapier',
  SALESFORCE = 'salesforce',
  MERGE = 'merge',
}
